export default __webpack_public_path__ + "static/media/ic_back_medical.bb3863c5.svg";